import React, { useEffect } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import "../assets/css/auth.css";
import SignupForm from "../components/signup/SignupForm";
import Verification from "../components/signup/Verification";
import SocialAuth from "../components/social-auth/SocialAuth";
import AuthLeftContainer from "../common/AuthLeftContainer";

const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const SignupContent = () => {
  const [searchParams] = useSearchParams();
  const activationKey = searchParams.get("key");
  const email = searchParams.get("email");

  useEffect(() => {
    document.body.classList.add("show-recaptcha");
    return () => {
      document.body.classList.remove("show-recaptcha");
    };
  }, []);

  return (
    <Container
      fluid
      className="min-vh-100 h-100 auth p-0 text-black position-relative overflow-x-hidden signup-page"
    >
      <Row className="min-vh-100 h-100">
        <Col lg={4} className="d-none p-0 d-lg-block">
          <AuthLeftContainer />
        </Col>

        <Col xs={12} lg={8} className="p-5 overflow-y-scroll">
          <div className="text-right heading12px fw-semibold">
            Already have an account?{" "}
            <NavLink
              to="/signin"
              className="heading12px text-theme fw-semibold"
            >
              SignIn
            </NavLink>
          </div>
          <div className="d-flex flex-column auth-card justify-content-center h-100 mt-4 mt-lg-0">
            {!activationKey ? (
              <div className="login-card">
                <div className="heading20px fw-semibold pb-4">
                  Sign Up for Free
                </div>
                <SocialAuth />
                <div className="heading8px text-gray py-4 text-center seprater">
                  Or Sign up with
                </div>
                <SignupForm />
              </div>
            ) : (
              <Verification email={email} activationKey={activationKey} />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

const Signup = () => {
  if (siteKey) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
        <SignupContent />
      </GoogleReCaptchaProvider>
    );
  }
  return <SignupContent />;
};

export default Signup;
